import React, { useEffect } from 'react'
import axios from "axios"
import { Link, useNavigate } from "react-router-dom"
import { useSnackbar } from "notistack"

import ThirdPartyLogin from "../../components/buyer/ThirdPartyLogin"
import { hostNameBack } from '../../utils/constants'
import Loader from '../../utils/Loader'
import { Helmet } from 'react-helmet'

function Register() {

  let [username, setUsername] = React.useState("");
  let [email, setEmail] = React.useState("");
  let [password, setPassword] = React.useState("");
  let [confirmPass, setConfirmPass] = React.useState("");
  let [passwordHidden, setPasswordHidden] = React.useState(true);
  let [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const registerUser = (e) => {
    e.preventDefault();

    if (!username || !email || !password || !confirmPass) {
      enqueueSnackbar("All fields are Required!", { variant: "error" });
      return;
    }

    setLoading(true);
    axios.post(`${hostNameBack}/api/v1/auth/register`, { username, email, password, confirmPass }).then(() => {
      enqueueSnackbar("An Email has been sent to you for verification... Please check your inbox!", { variant: "success" })
      navigate("/login")
    }).catch((e) => {
      enqueueSnackbar(e.response?.data?.error, { variant: "error" })
    }).finally(() => {
      setLoading(false);
    })
  }

  useEffect(() => {
    return () => {
      document.title = "Buylio | Buy & Sell Tech Products & Services Online";
    };
  }, []);

  return (
    <div className='registerDiv'>

      <Helmet>
        <title>Sign Up | Create Your Marketplace Account</title>
        <meta name="description" content="Join Buylio and unlock opportunities to buy, sell, and connect. Create your account in minutes with secure registration." />
        <meta name="keywords" content="signup, register, Buylio, marketplace account, new user registration" />
        <meta property="og:title" content="Sign Up for Buylio" />
        <meta property="og:description" content="Create your Buylio account and start your marketplace journey today" />
        <meta property="og:image" content="https://faithzy.com/assets/images/logo.svg" />
        <meta property="og:url" content="https://faithzy.com/register" />
        <link rel="canonical" href="https://faithzy.com/register" />
      </Helmet>

      <Link to="/" className="faithzyLogoDiv">
        <img src="./assets/images/logo.svg" className='faithzyLogo' alt="Buylio Logo" />
      </Link>

      <div className="registerBanner">
        <img src="./assets/images/register.svg" alt="SignUp Banner" />
      </div>

      <section className='section'>
        <div className="registerContent">

          <form className="registerRight form" onSubmit={registerUser}>
            <h1 className='primaryHeading signUpHeading'>Sign<span>Up</span></h1>
            <ThirdPartyLogin />
            <div className="orLine">OR</div>
            <div className="registerRightLower">
              <h2 className='secondaryHeading'>Sign up with your email address</h2>
              <div className='inputDiv'>
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  name='username'
                  className='inputField'
                  placeholder='Enter your username'
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div className='inputDiv'>
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  name='email'
                  className='inputField'
                  placeholder='Enter your email address'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div className='inputDiv'>
                <div className="passwordFieldUpper">
                  <label htmlFor="password">Password</label>
                  <div className='hidePasswordBtn'
                    onClick={() => setPasswordHidden((oldValue) => !oldValue)}
                  >
                    <i className={passwordHidden ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}></i>
                  </div>
                </div>
                <input
                  type={passwordHidden ? "password" : "text"}
                  name='password'
                  className='inputField'
                  placeholder='Enter your password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
                <p className='passInstructions'>Use 8 or more characters with a mix of letters, numbers & symbols</p>
              </div>
              <div className='inputDiv'>
                <label htmlFor="confirmPass">Confirm Password</label>
                <input
                  type={passwordHidden ? "password" : "text"}
                  name='confirmPass'
                  className='inputField'
                  placeholder='Re-write Password'
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div className='inputDiv'>
                <input
                  type="submit"
                  className='primaryBtn'
                  value="Sign Up"
                  disabled={loading}
                />
              </div>
              <div className="loginInsteadDiv">Already have an account? <Link to="/login">Login!</Link></div>

            </div>
          </form>

        </div>
      </section>
      {loading && <Loader type="checkmate" />}
    </div>
  )
}

export default Register